import React, { useEffect, useState } from "react";

import {Button, Form, FormInstance, Input, Radio, Select} from "antd";
import { useAppSelector } from "../../../../store/hooks";
import { selectAppEntities, selectAppIds } from "../../../../store/community/appsSlice";
import { EntityId } from "@reduxjs/toolkit";
import { filterOption } from "../../../../helpers/FormHelper";
import { KindInterface } from "../../../../store/community/kindsSlice";
import communityApi from "../../../../api/communityApi";

type ParamsType = {
  app_id?: number;
  second_app_id?: number;
  target?: 'content' | 'assets';
}

interface propsInterface {
  params?: ParamsType;
  onFinish: Function;
  form: FormInstance;
  loading: boolean;
}

const _FormFeed = ({ loading, params, onFinish, form }: propsInterface) => {
  const apps = useAppSelector(selectAppEntities);
  const appIds = useAppSelector(selectAppIds);
  const [kinds, setKinds] = useState<KindInterface[]>([]);

  useEffect(() => {
    form.resetFields();
  }, [params?.app_id, params?.second_app_id, params?.target, form]);

  useEffect(() => {
    if (!params?.app_id || !params?.target) {
      setKinds([]);
      return;
    }

    communityApi.get('/onesky/kinds', { params: { app_id: params.app_id, target: params.target } })
      .then(response => setKinds(response.data.kinds || []))
      .catch(() => setKinds([]));
  }, [params?.app_id, params?.target]);

  const renderAppOption = (id: EntityId) => {
    const item = apps[id];

    if (!item || params?.app_id === id) {
      return null;
    }

    return <Select.Option key={id} value={id} title={item.name}>{item.name}</Select.Option>
  }

  const AppSelect = () =>  (
    <Form.Item
      label='From: '
      name='second_app_id'
    >
      <Select
        allowClear
        showSearch
        style={{ width: 220 }}
        filterOption={filterOption}
        placeholder='select app'
      >
        {apps && appIds.map(renderAppOption)}
      </Select>

    </Form.Item>
  )

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="inline"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <AppSelect />

      {!!kinds.length && (
        <Form.Item
          label='Kind: '
          name='kind_id'
        >
          <Select
            allowClear
            showSearch
            style={{ width: 220 }}
            filterOption={filterOption}
            placeholder='no kind'
          >
            {kinds.map(item => (
              <Select.Option key={item.id} value={item.id} title={item.name}>{item.name}</Select.Option>
            ))}
          </Select>
        </Form.Item>
      )}

      <Form.Item name='target'>
        <Radio.Group>
          <Radio value='content'>Content</Radio>
          <Radio value='assets'>Assets</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item>
        <Button
          className="v-btn v-btn-primary v-btn-w-auto"
          type="primary"
          htmlType="submit"
          loading={loading}
        >
          Feed
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _FormFeed;
